import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { Divider } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'
import { Page } from '@flecto/ui/saas'

import { ScheduleControls } from '../components/ScheduleControls/ScheduleControls'
import { ScheduleList } from '../components/ScheduleList/ScheduleList'
import { TogglePageScheduler } from '../components/TogglePageScheduler/TogglePageScheduler'
import { useBookingCalendar } from '../hooks/useBookingCalendar'

export function SchedulePage() {
  const { calendar, handlePreviousWeek, handleNextWeek, handleTodayWeek } =
    useBookingCalendar()
  const { t } = useTranslation('saas', { keyPrefix: 'schedule' })

  return (
    <Page withContainer>
      <Page.Title>{t('schedule')}</Page.Title>
      <Page.Actions>
        <ScheduleControls
          previousDate={{
            label: <Icon icon={faChevronLeft} />,
            onClick: handlePreviousWeek,
          }}
          today={{
            label: t('today'),
            onClick: handleTodayWeek,
          }}
          nextDate={{
            label: <Icon icon={faChevronRight} />,
            onClick: handleNextWeek,
          }}
        />
        <Divider orientation='vertical' size='xs' mx='md' h={30} mt='sm' />
        <TogglePageScheduler />
      </Page.Actions>
      <Page.Content>
        <ScheduleList calendar={calendar} />
      </Page.Content>
    </Page>
  )
}
